import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ConfirmationComponent } from '../../Confirmation/confirmation/confirmation.component';
import { ThumbnailAttachmentComponent } from '../../thumbnail-attachment/thumbnail-attachment.component';

@Component({
  selector: 'app-attachment',
  standalone: true,
  imports: [CommonModule,ThumbnailAttachmentComponent],
  templateUrl: './attachment.component.html',
  styleUrl: './attachment.component.scss'
})
export class AttachmentComponent {
  isDisabled: boolean = false;
  user = [] as any;
  @Input() Attachments: any = [];
  @Input() IsView = false;

  constructor(
    private activeModal: NgbActiveModal,
    protected common: CommonService,
    private toast: ToastService,
    private utility: UtilityService,
    private session: SessionService,
    private modalService: NgbModal,
  ) {
    this.user = this.session.GetUserDetails();
  }


  upload(event: any, Folder: any, Tag = '') {
    try {
      if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.UploadServices(Folder, reader.result, Tag, null, event.target.files[0].type.split('/')[1]);
          event.target.value = null;
        };
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event.target.value = null;
      }
    } catch (e) { }
  }

  UploadServices(Folder: string, Base64: any, Tag = '', index = null, type = '') {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "" && response.FileName != undefined) {
        this.Attachments.push(response);
      } else {
        this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  remove(index: number) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result: any) => {
      if (result) {
        this.Attachments.splice(index, 1);
      }
    });
  }

  close() {
    this.activeModal.close(this.Attachments);
  }
}
